import React from 'react';

import styles from './AppBar.module.css';
import back from '../../assets/back.png';

const AppBar = () => {
  return (
    <div className={styles['appbar']}>
      <div className={styles['appbar-left']}>
        <img
          src={back}
          alt='back button'
          className={styles['back-button']}
          onClick={() => {
            window?.ReactNativeWebView?.postMessage(
              JSON.stringify({ emailVerified: false, command: 'back' })
            );
          }}
        />
      </div>
      <h1 className={styles['title']}>Verify Email</h1>
      <div className={styles['appbar-right']}></div>
    </div>
  );
};

export default AppBar;
